import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { PutUnitsToCGCParam, SkillsManagementCentersService } from 'src/Services/API';

import { MutationKeys, QueryKeys } from '../types';

export const useOverrideCGCUnits = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.addCGCToUnits],
    async (params: PutUnitsToCGCParam) => {
      return SkillsManagementCentersService.skillsManagementCentersControllerOverrideUnitsToCgc({
        body: params,
      });
    },
    {
      onSuccess: () => {
        toast.success('les unités ont été retirées du CGC sélectionné');
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchCGCs] });
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchUnitsWithoutCGCs] });
      },
      onError: (error: AxiosError) => {
        switch (error.response?.status) {
          case 403:
            toast.error('droits insuffisants pour retirer ces unités au CGC sélectionné');
            break;
          default:
            toast.error('erreur lors de la suppression des unités au CGC sélectionné');
            break;
        }
      },
    }
  );
};
